import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_Parkings } from 'redux/modules/parkings/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'

export const useDeleteParkingConfirm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.deleteParkingConfirm)

  const parkingId = useSelector(({ modals }: TState) => modals.data.parkingId)

  const onSubmit = useCallback(() => {
    dispatch(Actions_Parkings.saga.deleteParking({ id: parkingId }))
    dispatch(Actions_Modals.store.hideModal())
  }, [dispatch, parkingId])

  const onCancel = useCallback(() => dispatch(Actions_Modals.store.hideModal()), [dispatch])
  return { t, onSubmit, onCancel }
}
